/* MontyLab redesign — smooth open/close animation for the custom FAQ
   accordions (.ml-faq__item <details> blocks used on the service pages).
   Native <details> snaps open/closed instantly; this animates the height
   via the Web Animations API using measured pixel values (not "auto"),
   which is the reliable way to animate a <details> element. */
(function () {
  function setUpAnimatedDetails(details) {
    const summary = details.querySelector(':scope > summary');
    const content = summary ? summary.nextElementSibling : null;
    if (!summary || !content) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let animation = null;
    let isClosing = false;
    let isExpanding = false;

    summary.addEventListener('click', function (event) {
      event.preventDefault();
      details.style.overflow = 'hidden';

      if (prefersReducedMotion) {
        details.open = !details.open;
        return;
      }

      if (isClosing || !details.open) {
        open();
      } else if (isExpanding || details.open) {
        close();
      }
    });

    function open() {
      details.style.height = details.offsetHeight + 'px';
      details.open = true;
      window.requestAnimationFrame(function () {
        expand();
      });
    }

    function expand() {
      isExpanding = true;
      const startHeight = details.offsetHeight + 'px';
      const endHeight = summary.offsetHeight + content.offsetHeight + 'px';

      if (animation) animation.cancel();

      animation = details.animate(
        { height: [startHeight, endHeight] },
        { duration: 300, easing: 'cubic-bezier(0.5, 0.02, 0, 1)' }
      );
      animation.onfinish = function () {
        finish(true);
      };
      animation.oncancel = function () {
        isExpanding = false;
      };
    }

    function close() {
      isClosing = true;
      const startHeight = details.offsetHeight + 'px';
      const endHeight = summary.offsetHeight + 'px';

      if (animation) animation.cancel();

      animation = details.animate(
        { height: [startHeight, endHeight] },
        { duration: 300, easing: 'cubic-bezier(0.5, 0.02, 0, 1)' }
      );
      animation.onfinish = function () {
        finish(false);
      };
      animation.oncancel = function () {
        isClosing = false;
      };
    }

    function finish(open) {
      details.open = open;
      animation = null;
      isClosing = false;
      isExpanding = false;
      details.style.height = '';
      details.style.overflow = '';
    }
  }

  function init() {
    document.querySelectorAll('.ml-faq__item').forEach(function (el) {
      if (el.dataset.mhFaqAnimated) return;
      el.dataset.mhFaqAnimated = 'true';
      setUpAnimatedDetails(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
